// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"04572eec","251":"25586ada","334":"a4ee71cf","348":"861a340f","571":"fc752e64"}[chunkId] + ".chunk.js";
};